import { inject } from 'mobx-react'
import React, { FC, useContext, useState } from 'react'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { DeleteConfirmationModal } from './DeleteConfirmationModal'
import './digitalSignage.scss'
import { DigitalSignageContext } from './DigitalSignageContext'
import { DigitalSignageAPIState, DigitalSignageCardType } from './enums'
interface IDigitalSignageCardProps {
  title: string
  id: string
  type: DigitalSignageCardType
  buttonText: string
  onButtonClick?: () => void
  deleteMessage: string
  currentCompanyStore?: CurrentCompanyStore
  retailerId?: string
}

export const DigitalSignageCard: FC<IDigitalSignageCardProps> = inject('currentCompanyStore')(
  ({
    currentCompanyStore,
    title,
    buttonText,
    onButtonClick,
    id,
    type,
    deleteMessage,
    retailerId,
  }) => {
    const [modalOpened, setModalOpened] = useState(false)
    const tenantId = currentCompanyStore?.company?.id.toString()
    const { removeDevice, removeSignage, status } = useContext(DigitalSignageContext)

    const deleteItem = async () => {
      if (type === DigitalSignageCardType.DEVICE && tenantId && retailerId) {
        await removeDevice(tenantId, retailerId, id)
        setModalOpened(false)
        return
      }

      if (type === DigitalSignageCardType.SIGNAGE && tenantId) {
        await removeSignage(tenantId, id)
        setModalOpened(false)
        return
      }
    }
    return (
      <div>
        <div className='card digital-signage-card'>
          <header className='card-header digital-signage-card-header'>
            <h6 className='digital-signage-title'>{title}</h6>
          </header>

          <main className='card-body digital-signage-card-body'>
            <div>
              <i className='fa fa-key mr-2' aria-hidden='true' />
              <a onClick={onButtonClick}>{buttonText}</a>
            </div>
          </main>
          <footer>
            <div className='d-flex w-100 justify-content-end'>
              <button
                className='btn'
                style={{ background: 'transparent' }}
                onClick={() => setModalOpened(true)}
              >
                <span className='fa fa-trash fa-lg' />
              </button>
            </div>
          </footer>
        </div>
        <DeleteConfirmationModal
          isOpen={modalOpened}
          name={title}
          message={deleteMessage}
          onClose={() => setModalOpened(false)}
          isDeleting={[
            DigitalSignageAPIState.DELETING_DEVICE,
            DigitalSignageAPIState.DELETING_SIGNAGE,
          ].includes(status)}
          onConfirm={() => deleteItem()}
        />
      </div>
    )
  },
)
